import { PriceUnits } from "../../../lib/const/priceUnits";
import { RateModes } from "../../../lib/const/rateModes";

/**
 * Дефолтная единица тарификации в зависимости от вида цены
 * @param {boolean} isPacketTariff
 * @return {RateTypes | undefined}
 */

export const getPriceUnitId = (
  isPacketTariff: boolean,
  rateModeId?: RateModes
): PriceUnits | undefined => {
  if (isPacketTariff) {
    return PriceUnits.PIECE;
  }
  switch (rateModeId) {
    case RateModes.ONE_TIME:
      return PriceUnits.IN_FACT;
    case RateModes.PERIODIC:
      return undefined;
    case RateModes.TRAFFIC:
      return PriceUnits.PIECE;
    default:
      return undefined;
  }
};
